<div 
    class="widget-area" 
    [ngClass]="data.isSelected ? 'widget-selected' : 'widget-unselected'"
    cdkDrag [cdkDragData]="data">
    <!-- Titlebar for Widget -->         
    <div class="widget-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">
        <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon>        
        <mat-label class="top-bar-title" fxFlex="grow" (click)="onSelect($event)"><b>{{data.label}}</b></mat-label>
        <img src="assets/img/icons/text.png">
        <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
        <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">minimize</mat-icon>
        <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMaximize()">settings</mat-icon>                       
    </div>    

    <!-- Config data for Widget --> 
    <div *ngIf="!isMinimized">
        <appMetadataWidget [data]="data"></appMetadataWidget>
        <div class="metadata-block">
            <div fxLayout="row nowrap">
                <div class="metadata-key">Text:</div>
                <input matInput class="metadata-value" placeholder="Label" type="text" [(ngModel)]="data.label">
            </div>
            <div fxLayout="row nowrap">
                <div class="metadata-key">Level:</div>
                <input matInput class="metadata-label" placeholder="Label" label="Level" type="number" min="1" max="6"
                    [(ngModel)]="data.level">
            </div>
        </div>
    </div>
</div>
